module.exports = __webpack_public_path__ + "static/media/auto_save.bcba406d.png";